export default "__VITE_ASSET__CapWvhp$__"